import axios from 'axios';

const getAvaliacoes = params => axios.get('/avalicao-compra', { params });
const createAvaliacaoCompra = data => axios.post('/avalicao-compra', data);

export default {
  getAvaliacoes,
  createAvaliacaoCompra,
};
